const order = {
    getlist: 'order/getlist',
    add: 'order/add',
    update: 'order/update',
    remove: 'order/remove',
    get: 'order/get',
    getall: 'order/getall',
    clearcache: 'order/clear-cache',
}
export default order
